import React from 'react';
import { IconProps } from '../types/types';

const XVG: React.FC<IconProps> = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg"  xmlSpace="preserve" viewBox="0 0 283.5 283.5" role="img" {...props}><path style={{fill: '#37bde2'}} d="m216.5 15.8-74.8 172L67 15.8H32.3l109.4 251.9L251.2 15.8z"/><path style={{fill: '#37bde2'}} d="m141.7 108.4 39.2-92.6h-78.4z"/></svg>
);

export default XVG;
